import axios from "axios";
import { MAINTENANCE_CONFIG } from 'utils/Config'
const baseAPIinstance = axios.create({
  timeout: 5000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});
export function getMaintenanceInfo() {
  const timestampQuery = new Date().getTime()
  return baseAPIinstance
    .get(`${MAINTENANCE_CONFIG}?_t=${timestampQuery}`)
    .catch((error) => error.response);
}